export default __webpack_public_path__ + "static/media/icon_start_guide.86df13e8.svg";